// @ts-nocheck
import React, { useMemo } from "react";

const getBounds = (events, center) => {
  const lats = events.map((event) => event.lat ?? event.latitude).filter((v) => Number.isFinite(v));
  const lngs = events.map((event) => event.lng ?? event.longitude).filter((v) => Number.isFinite(v));
  lats.push(center.lat);
  lngs.push(center.lng);
  const minLat = Math.min(...lats);
  const maxLat = Math.max(...lats);
  const minLng = Math.min(...lngs);
  const maxLng = Math.max(...lngs);
  return { minLat, maxLat, minLng, maxLng };
};

const getPinPosition = (event, bounds) => {
  const lat = event.lat ?? event.latitude;
  const lng = event.lng ?? event.longitude;
  const latRange = bounds.maxLat - bounds.minLat || 1;
  const lngRange = bounds.maxLng - bounds.minLng || 1;
  const top = ((bounds.maxLat - lat) / latRange) * 100;
  const left = ((lng - bounds.minLng) / lngRange) * 100;
  return { top: `${top}%`, left: `${left}%` };
};

export default function EventsMap({ events, center, onSelect, mapKey }) {
  const bounds = useMemo(() => getBounds(events, center), [events, center]);

  return (
    <div className="events-map">
      {mapKey ? (
        <iframe
          className="map-iframe"
          title="Events map"
          src={`https://www.google.com/maps/embed/v1/view?key=${mapKey}&center=${center.lat},${center.lng}&zoom=9&maptype=roadmap`}
          loading="lazy"
          allowFullScreen
        />
      ) : (
        <div className="events-map-bg">
          <div className="map-grid" />
        </div>
      )}
      <div className="map-pins">
        {events
          .filter((event) => Number.isFinite(event.lat ?? event.latitude) && Number.isFinite(event.lng ?? event.longitude))
          .map((event) => {
          const position = getPinPosition(event, bounds);
          return (
            <button
              key={event.id}
              type="button"
              className={`map-pin ${event.eventType.toLowerCase()}`}
              style={position}
              onClick={() => onSelect(event)}
              aria-label={`View ${event.name}`}
            />
          );
          })}
      </div>
    </div>
  );
}
